import { getApiClient } from '..';
import getSession from '../../utilities/getSession';
import withAuthenticationHeaders from '../../utilities/withAuthenticationHeaders';

export default function fetchPaymentRequest(
  id: string,
  sessionId?: string,
): Promise<io.flow.v0.models.PaymentRequest> {
  return getSession({
    sessionId,
  }).then((session) => getApiClient().paymentRequest.getById({
    id,
    organization: session.organization,
    headers: withAuthenticationHeaders(session.id),
  }).then((response) => {
    if (response.ok) {
      return response.body;
    }
    throw new Error(`fetchPaymentRequest: Error fetching PR id [${id}]; status: ${response.status}`);
  }));
}
